import FAQ from 'src/app/FAQ/FAQ'

export default FAQ
